/** 4px spacing scale. Keys are used as `gap={4}`; `0.5` emits as `--gg-space-0-5`. */
export const space = {
  0: '0',
  0.5: '2px',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  8: '32px',
  10: '40px',
  12: '48px',
  16: '64px',
  20: '80px',
} as const;

export type SpaceKey = keyof typeof space;

/** Fixed sizes: controls are thumb-sized (44px default), tap targets ≥ 44px. */
export const size = {
  controlSm: '36px',
  controlMd: '44px',
  controlLg: '52px',
  tapMin: '44px',
  iconSm: '16px',
  iconMd: '20px',
  iconLg: '24px',
  avatarSm: '24px',
  avatarMd: '36px',
  avatarLg: '48px',
  avatarXl: '72px',
  thumbSm: '48px',
  thumbMd: '72px',
  bottomNav: '64px',
  sidebar: '256px',
  content: '1120px',
  readable: '640px',
} as const;

/** Page gutter by breakpoint (base, md, lg). */
export const pageGutter = { base: '16px', md: '24px', lg: '32px' } as const;
